<template>
  <v-row>
    <v-col cols="12" v-for="(item, i) in localEducationParent.list" :key="i">
      <EducationDocComponent
        :index="i"
        :item="item"
        @set-data="setEducation($event, item)"
        @remove="removeEducation(item)"
      />
    </v-col>

    <v-col
      cols="12"
      class="d-flex justify-end pt-0"
      v-if="!localEducationParent.list.length"
    >
      <v-btn
        color="primary"
        outlined
        rounded
        @click="addEducation"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        Добавить документ об образовании
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import EducationDocComponent from '@/components/zvp/application-create/education-doc/EducationDoc'
import {EducationParent, Education} from '@/models'
import _cloneDeep from "lodash/cloneDeep";

export default {
  name: "EducationDoc",

  components: {
    Title,
    EducationDocComponent
  },

  props: {
    item: EducationParent
  },

  data: () => ({
    localEducationParent: new EducationParent(),
  }),

  computed: {},

  methods: {
    addEducation() {
      this.localEducationParent.list.push(new Education())
    },

    setEducation(event, item) {
      item.setProperties(event)
      this.$emit('set-data', this.localEducationParent)
    },

    removeEducation(item) {
      this.$emit('remove', item)
      //this.localEducationParent.remove(item)
    },
  },

  watch: {
    'item.list': {
      immediate: true,
      deep: true,
      handler(value) {
        this.localEducationParent = _cloneDeep(this.item)
        if (!value?.length) this.addEducation()
      }
    }
  }
}
</script>

<style scoped>
</style>
